import { memo } from 'react';
import { Card, Stack, Text, Group, Badge } from '@mantine/core';

interface SummaryItem {
  label: string;
  value: string | undefined;
  color: string;
}

interface SummaryCardProps {
  title: string;
  items: SummaryItem[];
  isVisible?: boolean;
}

const SummaryCard = memo<SummaryCardProps>(
  ({ title, items, isVisible = true }) => {
    if (!isVisible) return null;

    return (
      <Card withBorder p='md' bg='gray.0'>
        <Stack gap='xs'>
          <Text fw={500} size='sm'>
            {title}
          </Text>
          <Group gap='xs'>
            {items.map((item, index) => (
              <Badge key={index} color={item.color} variant='light'>
                {item.label}: {item.value || 'Non selezionato'}
              </Badge>
            ))}
          </Group>
        </Stack>
      </Card>
    );
  }
);

SummaryCard.displayName = 'SummaryCard';

export default SummaryCard;
